var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#131314",
    d: "M12.617 6.205A5.73 5.73 0 0 0 6.777.63 5.73 5.73 0 0 0 .92 6.181C.78 8.917 3.492 12.908 6.447 16.828a.415.415 0 0 0 .488.11.4.4 0 0 0 .14-.11c2.955-3.92 5.676-7.91 5.527-10.647zm-5.848 9.76C4.056 12.328 1.57 8.62 1.704 6.228a4.947 4.947 0 0 1 5.057-4.814 4.955 4.955 0 0 1 5.065 4.814c.149 2.391-2.282 6.1-5.057 9.737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#131314",
    d: "M6.8 3.226a2.987 2.987 0 1 0 0 5.974 2.987 2.987 0 0 0 0-5.974m0 5.182a2.203 2.203 0 1 1 0-4.406 2.203 2.203 0 0 1 0 4.406"
  })));
};
export default SvgLocation;